import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'RoleEdit',
  data: function data() {
    return {
      defaultCheckList: [21],
      selectMenuList: [],
      menuList: [],
      title: '',
      form: {
        name: '',
        id: null,
        roleMenus: []
      },
      rules: {
        name: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'blur'
        }],
        roleMenus: [{
          required: true,
          message: '请选择权限',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    selectMenu: function selectMenu(data, data1) {
      this.selectMenuList = data1.checkedNodes;
      var par = [];
      this.selectMenuList.forEach(function (res) {
        var parVo = {
          menuId: res.id
        };
        if (res.layer !== 1) {
          par.push(parVo);
        }
      });
      this.form.roleMenus = par;
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.name = null;
      this.form.id = null;
      this.form.roleMenus = [];
      this.initMenusData();
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.name = data.name;
      this.form.id = data.id;
      this.form.roleMenus = data.roleMenus;
      this.initMenusData();
    },
    updateApi: function updateApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.UPDATE_ROLE(_this.form);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    saveApi: function saveApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.SAVE_ROLE(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this3.form.id != null) {
            _this3.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this3.updateApi();
            }).catch(function () {
              _this3.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this3.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    recursionMenus: function recursionMenus(menus) {
      var childrens = [];
      for (var i = 0; i < menus.children.length; i++) {
        var menu = menus.children[i];
        var children = this.recursionMenus(menu);
        var menuJson = {
          id: menu.menuId,
          label: menu.title,
          type: menu.type,
          layer: menu.layer
        };
        if (children.length > 0) {
          menuJson.children = children;
        }
        if (this.disabled) {
          menuJson.disabled = this.disabled;
        }
        childrens.push(menuJson);
      }
      return childrens;
    },
    initMenusData: function initMenusData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res, menus, i, menu, children, menuJson, arr, k, menuSelect;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {};
              _context3.n = 1;
              return api.GET_MENU_LIST(par);
            case 1:
              res = _context3.v;
              menus = [];
              for (i = 0; i < res.body.length; i++) {
                menu = res.body[i];
                children = _this4.recursionMenus(menu);
                menuJson = {
                  id: menu.menuId,
                  label: menu.title,
                  type: menu.type,
                  layer: menu.layer
                };
                if (children.length > 0) {
                  menuJson.children = children;
                }
                if (_this4.disabled) {
                  menuJson.disabled = _this4.disabled;
                }
                menus.push(menuJson);
              }
              _this4.menuList = menus;
              arr = [];
              for (k = 0; k < _this4.form.roleMenus.length; k++) {
                menuSelect = _this4.form.roleMenus[k];
                arr.push(menuSelect.menuId);
              }
              _this4.defaultCheckList = arr;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};